export function getLogo(logoUrl = '', isNewTheme = false) {
  let url;

  try {
    url = new URL(logoUrl).href;
  } catch (e) {
    url = logoUrl ? `https://${isNewTheme ? 'lemanapro' : 'leroymerlin'}.ru${logoUrl}` : '';
  }

  return url;
}
